import React, { FunctionComponent } from 'react';
import { ListItem, ListItemIcon, ListItemText, Avatar, Grid, Typography } from '@material-ui/core';
import { makeStyles, useTheme, createStyles } from '@material-ui/styles';
import { useDrag } from 'react-dnd';
import { StubbornRoute } from '../../../../../../../business/StubbornRouter';
import { AppThemeType } from '../../../../../../../../theme';
import { link, router } from '../../../../../../../../theme/images';

const useStyles = makeStyles<AppThemeType>((theme) =>
  createStyles({
    icons: {
      display: 'flex',
      padding: 10,
      height: 40,
      width: 40,
      justifyContent: 'center',
      alignContent: 'center',
      backgroundColor: '#4b4e61',
    },
    title: {
      color: 'white',
      fontSize: 13,
      paddingTop: 5,
      fontWeight: 600,
    },
  }),
);

export interface ItemListProps {
  type: string;
  onClick: () => void;
}

interface DropResult {
  allowedDropEffect: string;
  dropEffect: string;
}

const actionImages: Record<string, string> = {
  route: link,
  router,
};

export const DraggableRouterItem: FunctionComponent<ItemListProps> = ({ type, onClick }) => {
  const theme = useTheme();
  //@ts-ignore
  const classes = useStyles(theme);

  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'router',
    item: { type },
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult<DropResult>();
      if (item && dropResult) {
        onClick();
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
      handlerId: monitor.getHandlerId(),
    }),
  }));

  return (
    <Grid ref={drag} style={{ backgroundColor: isDragging ? 'lightgrey' : '#4b4e61', margin: 5, width: '40%', height: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <Avatar src={actionImages[type.toLowerCase()]} className={classes.icons} />
      <Typography className={classes.title}>{type}</Typography>
    </Grid>
  );
};
